module.exports = __webpack_public_path__ + "static/img/section-1.95f85d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/section-1.jpg
// module id = Ia15
// module chunks = 1